import {
  Component,
  OnChanges,
  SimpleChanges,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef, OnInit, AfterViewInit,
} from '@angular/core';
import {Platform} from 'ionic-angular/index';
import {WxProvider} from '../../providers/wx/wx';

declare var PhotoClip: any;
declare var $: any;
declare var wx: any;

import * as html2canvas from 'html2canvas';
import {BaseConfigProvider} from "../../providers/base-config/base-config";
import {MyAlertProvider} from "../../providers/my-alert/my-alert";
import {global} from "../../environments/global";

/**
 * Generated class for the MyPhotoClipComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'my-photo-clip',
  templateUrl: 'my-photo-clip.html',
})
export class MyPhotoClipComponent implements AfterViewInit {
  @Input() qr_code;

  @Input() bg;

  @Output() result_cancel = new EventEmitter();

  @ViewChild('file') file: ElementRef;
  @ViewChild('okTrigger') okTrigger: ElementRef;

  @Input() clipWidth: number = 325;
  @Input() clipHeight: number = 488;

  is_weixin_upload;

  constructor(public platform: Platform,
              public wxService: WxProvider,
              public myAlertService: MyAlertProvider,) {
  }

  ngAfterViewInit(): void {
    if(!this.bg){
      this.getUploadImg(img => {
        new PhotoClip('#clipArea', {
          size: [this.clipWidth, this.clipHeight], //裁剪框大小
          outputSize: [0, 0], //打开图片大小，[0,0]表示原图大小
          img: img,
          qrCode: this.qr_code,
        });
      });
    } else {
      new PhotoClip('#clipArea', {
        outputQuality: 1,
        size: [this.clipWidth, this.clipHeight], //裁剪框大小
        outputSize: [this.clipWidth, this.clipHeight], //打开图片大小，[0,0]表示原图大小
        img: this.bg,
        qrCode2: this.qr_code,
        style: {
          maskBorder: 'none'
        },
      });
    }
  }

  getUploadImg(initArea) {
    if (BaseConfigProvider.is_weixin() && !BaseConfigProvider.isPc() && this.platform.is('ios')) {
      this.is_weixin_upload = true;
        wx.chooseImage({
          count: 1,
          sizeType: ['original'],
          sourceType: ['album'],
          success: (res) => {
            wx.getLocalImgData({
              localId: res.localIds[0],
              success: (local) => {
                initArea(local.localData);
              }
            });
          },
          cancel: () => {
            this.result_cancel.emit(true);
          }
        })
      // this.getSignature();
    } else {
      this.clipWithoutSDK();
    }
  }

  clipWithoutSDK() {
    this.is_weixin_upload = false;
    new PhotoClip('#clipArea', {
      size: [this.clipWidth, this.clipHeight], //裁剪框大小
      outputSize: [0, 0], //打开图片大小，[0,0]表示原图大小
      file: '#file',
      qrCode: this.qr_code,
    });

    let clickEvent = new MouseEvent('click');
    this.file.nativeElement.dispatchEvent(clickEvent);
  }

  /**
   * 开始剪裁*/
  changeToImg() {
    // console.log(this.shareImg);
    let clip = $('.photo-clip-layer')[0];
    let w = clip.offsetWidth;
    let h = clip.offsetHeight;
    let canvas = document.createElement('canvas');
    canvas.width = w * 2;
    canvas.height = h * 2;
    canvas.style.width = w * 2 + 'px';
    canvas.style.height = h * 2 + 'px';
    let context = canvas.getContext('2d');
    //然后将画布缩放，将图像放大两倍画到画布上
    context.scale(2, 2);

    document.getElementsByClassName('scroll-content')[0].scrollTop = 0;

    // this.shareImg.nativeElement.scrollTop = 0;

    return html2canvas(clip, {
      canvas: canvas,
      width: w,
      height: h,
      useCORS:true,

    });
  }

  // getSignature() {
  //   this.wxService.getSignature().subscribe(res => {
  //     wx.config({
  //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //       appId: global.app_id, // 必填，公众号的唯一标识
  //       timestamp: res['content']['timestamp'], // 必填，生成签名的时间戳
  //       nonceStr: res['content']['noncestr'], // 必填，生成签名的随机串
  //       signature: res['content']['signature'], // 必填，签名
  //       jsApiList: [
  //         'chooseImage',
  //         'uploadImage',
  //         'getLocalImgData',
  //         'downloadImage',
  //       ], // 必填，需要使用的JS接口列表
  //     });
  //   }, err => {
  //     // let alertObj = {
  //     //   type: 'error',
  //     //   title: '创建拉新任务失败',
  //     //   message: global.bot_name + '服务器遇到点难题，我们正在抢修...',
  //     //   success: {
  //     //     text: '知道了',
  //     //   }
  //     // };
  //     // this.myAlertService.showAlert(alertObj);
  //   });
  // }

  test(files) {
    // alert('file');
  }
}



// WEBPACK FOOTER //
// ./src/components/my-photo-clip/my-photo-clip.ts